import { useState } from 'react';
import { Spinner, useLastUnratedRide, useSocketEvent } from '@mobi/web';
import { useRide } from '../useRide.js';
import type { Ride } from '../useRide.js';
import { RequestRide } from '../components/RequestRide.js';
import { ActiveRide } from '../components/ActiveRide.js';
import { RatePrompt } from '../components/RatePrompt.js';

export function Home() {
  const { ride, loading, driverPosition, refresh, socket } = useRide();
  const { pending, recheck, dismiss } = useLastUnratedRide<Ride>(ride?.id ?? null);
  const [notice, setNotice] = useState<string | null>(null);

  /**
   * `no_drivers` não é estado ativo — a corrida sai de /rides/active e a
   * tela volta ao pedido. Sem este aviso, o passageiro veria a busca
   * simplesmente desaparecer sem explicação.
   */
  useSocketEvent<{ status?: string }>(socket, 'ride:status', (payload) => {
    if (payload?.status === 'no_drivers') {
      setNotice('Nenhum motorista disponível por perto agora. Tente de novo em alguns minutos.');
    }
    if (payload?.status === 'cancelled') {
      setNotice('A corrida foi cancelada.');
    }
  });

  if (loading) {
    return (
      <div className="grid h-full place-items-center text-brand">
        <Spinner className="h-8 w-8" />
      </div>
    );
  }

  if (ride) {
    return <ActiveRide ride={ride} driverPosition={driverPosition} onChanged={refresh} />;
  }

  if (pending) {
    return (
      <RatePrompt
        ride={pending}
        onDone={() => {
          dismiss(pending.id);
          void recheck();
        }}
      />
    );
  }

  return (
    <div className="relative h-full">
      {notice && (
        <div className="pt-safe absolute inset-x-0 top-0 z-10 px-4">
          <div
            role="status"
            className="flex items-start gap-3 rounded-2xl bg-warn/15 px-4 py-3 text-sm text-warn"
          >
            <span className="flex-1">{notice}</span>
            <button type="button" onClick={() => setNotice(null)} aria-label="Fechar aviso">
              ✕
            </button>
          </div>
        </div>
      )}
      <RequestRide
        onCreated={() => {
          setNotice(null);
          void refresh();
        }}
      />
    </div>
  );
}
